import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { ApiKeyEntity } from './api-key.entity';
import { BaseEntity } from './base.entity';

@Index('fk_api_key__id_action', ['fkApiKeyId'], {})
@Index('unique_api_key_action', ['fkApiKeyId', 'action'], { unique: true })
@Entity('_rbac_action__api_key')
export class RbacActionApiKeyEntity extends BaseEntity {
	@Column('int', { name: '_fk_api_key__id', unsigned: true })
	public fkApiKeyId!: number;

	/**
	 * The action string (e.g., "clients:read", "orders:create")
	 * Stored as string rather than FK for flexibility
	 */
	@Column('varchar', { name: '_action', length: 255 })
	public action!: string;

	@ManyToOne(() => ApiKeyEntity, (apiKey) => apiKey.rbacActions, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_api_key__id', referencedColumnName: 'id' }])
	public apiKey!: ApiKeyEntity;
}
